module.exports = "**CID** - Content Identifier. An unique address for a block of data in IPFS that is derived from its content.\n"